import { Components, Theme } from "@mui/material";

declare module "@mui/material/Dialog" {}

export const MuiDialog: Components<Theme>["MuiDialog"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      "& .MuiDialog-paper	": {
        width: "612px",
        padding: theme.spacing(3),
        borderRadius: theme.spacing(2),
      },
      ".MuiDialogTitle-root": {
        padding: 0,
        marginBottom: theme.spacing(1),
      },
      ".MuiDialogContent-root": {
        padding: 0,
      },
      ".MuiDialogActions-root": {
        padding: 0,
      },
    }),
  },
};
